import { io, Socket } from 'socket.io-client';
import { getStoredAuthToken } from './authToken';

const SOCKET_URL = 'https://cafeappmore.com';

let socket: Socket | null = null;

// 관리자 JWT로 인증해 store:{storeId} 룸에 자동 join한다(서버 sockets/index.js 참고).
// REST 폴링(useOrderPolling)은 그대로 두고, 소켓은 즉시 갱신을 위한 보조 채널로 사용한다.
export function getAdminSocket(): Socket {
  if (socket) return socket;

  socket = io(SOCKET_URL, {
    auth: { token: getStoredAuthToken() },
  });

  return socket;
}
